import { useState, useEffect } from "react";
import {
  Button,
  TextField,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Select,
  MenuItem,
  Typography,
  Box,
  Grid,
  InputAdornment,
  FormLabel,
  Alert,
  Switch,
  useMediaQuery,
  CircularProgress,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
} from "@mui/material";
import { PlusSquare, Tag, X as CloseIcon } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useNavigate, useLocation, useParams, useSearchParams } from "react-router-dom";
import { PetFormHeader } from "../components/PetFormHeader";
import {
  createPet,
  getPetBasicInfo,
  updatePetBasicInfo,
  updatePetImage,
  getDogBreeds,
  getCatBreeds,
  getTagInfo,
  getPetInfobyTagId,
  deletePetLostRecord,
  getPetMedical,
  getPetMedication,
  getPetVaccination,
  getPetDeworming,
} from "../services/api";
import Cookies from "js-cookie";
import { validateDate, convertFromISO } from "../utils/dateValidation";
import DatePickerField from "../components/DatePickerField";
import { validatePetPhoneNumber } from "../utils/validation";
import { useTranslation } from 'react-i18next';
import { set } from "lodash";

const Label = ({ children, htmlFor, className, ...props }) => (
  <Typography
    component="label"
    htmlFor={htmlFor}
    className={className}
    variant="body2"
    color="textPrimary"
    {...props}
  >
    {children}
  </Typography>
);

const Textarea = ({ className, ...props }) => (
  <TextField
    multiline
    rows={4}
    variant="outlined"
    fullWidth
    className={className}
    sx={{
      "& .MuiOutlinedInput-root": {
        backgroundColor: "white",
      },
    }}
    {...props}
  />
);

const PetBasic = () => {
  const id = Cookies.get("id");
  const navigate = useNavigate();
  const location = useLocation();
  const { petId } = useParams();
  const [buttonLoading, setButtonLoading] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const { t, i18n } = useTranslation();
  const [dateErrors, setDateErrors] = useState({});
  const [fieldErrors, setFieldErrors] = useState({});
  const [detachTag, setDetachTag] = useState(false);
  const [embedTag, setEmbedTag] = useState(false);
  const [petData, setPetData] = useState(location.state?.petData);
  const [basicInfo, setBasicInfo] = useState({
    name: "",
    birthday: "",
    sex: "",
    sterilization: "",
    status: "",
    animal: "",
    breed: "",
    bloodType: "",
    weight: "",
    features: "",
    info: "",
    owner: "",
    petNumber: "",
    ngoId: "",
    tagId: "",
    ownerContact1: "",
    ownerContact2: "",
    contact1Show: false,
    contact2Show: false,
    receivedDate: "",
  });
  const [isToggled, setIsToggled] = useState(false);
  const [isToggled2, setIsToggled2] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [imagePreviews, setImagePreviews] = useState([]); // Array of preview URLs
  const [imageFiles, setImageFiles] = useState([]);       // Array of File objects
  const [removedImageIndices, setRemovedImageIndices] = useState([]); // Track indices of removed images from AWS
  const [existingImagesCount, setExistingImagesCount] = useState(0); // Track original image count from AWS
  const [isEditMode, setIsEditMode] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [BackColor, setBackColor] = useState("");
  const [UpdateMessage, setUpdateMessage] = useState("");
  const isMobile = useMediaQuery("(max-width:900px)");
  const [searchParams] = useSearchParams();
  const EmbeddedtagId = searchParams.get('qr') || '';
  const [showFaceID, setShowFaceID] = useState(false);
  const [showPetLost, setShowPetLost] = useState(false);
  const [newPetID, setNewPetID] = useState("");
  const [buttonLoading2, setButtonLoading2] = useState(false);
  const [inputError, setInputError] = useState("");
  const [TagId, setTagId] = useState("");
  const getUserId = () => {
    const id = Cookies.get("id");
    return id;
  };

  const submitTagId = async (tagId) => {
    setButtonLoading2(true);
    const userId = getUserId();
    try {
      const tagInfo = await getTagInfo(tagId);
      const isStaffVerified = tagInfo.data.form.staffVerification;
      if (isStaffVerified) {
        try {
          const petInfo = await getPetInfobyTagId(tagId);
          if (petInfo.status === 200) {
            setInputError(t('ErrorAlreadyTagExists'));
            setButtonLoading2(false);
          }
        } catch (error) {
          if (error.status === 404) {
            // 404 is expected - tag is available
            basicInfo.tagId = tagId;
            setEmbedTag(false);
            setButtonLoading2(false);
          } else {
            // Handle other errors
            setInputError(t('InputError'));
            setButtonLoading2(false);
          }
        }
      } else {
        setInputError(t('InputError'));
        setButtonLoading2(false);
      }
    } catch (error) {
      setInputError(t('InputError'));
      setButtonLoading2(false);
    }

  }

  const handleToggleChange = (event) => {
    setIsToggled(event.target.checked);
  };

  const handleToggleChange2 = (event) => {
    setIsToggled2(event.target.checked);
  };

  // Breeds data state
  const [dogBreeds, setDogBreeds] = useState([]);
  const [catBreeds, setCatBreeds] = useState([]);
  const [breedsLoading, setBreedsLoading] = useState(true);
  const [dogBreedsMapping, setDogBreedsMapping] = useState({});
  const [catBreedsMapping, setCatBreedsMapping] = useState({});

  // Load dog breeds data
  const loadDogBreeds = async (lang) => {
    try {
      const response = await getDogBreeds(lang);
      const breedsData = response.data.result || [];
      setDogBreeds(breedsData);

      // Load the opposite language for mapping
      const oppositeLang = lang === 'en' ? 'zh' : 'en';
      const oppositeResponse = await getDogBreeds(oppositeLang);
      const oppositeBreedsData = oppositeResponse.data.result || [];

      // Create a mapping between the two languages
      const mapping = {};
      breedsData.forEach((breed, index) => {
        if (oppositeBreedsData[index]) {
          mapping[breed] = oppositeBreedsData[index];
          mapping[oppositeBreedsData[index]] = breed;
        }
      });
      setDogBreedsMapping(mapping);
    } catch (err) {
      console.error("Error loading dog breeds:", err);
    }
  };

  // Load cat breeds data
  const loadCatBreeds = async (lang) => {
    try {
      const response = await getCatBreeds(lang);
      const breedsData = response.data.result || [];
      setCatBreeds(breedsData);

      // Load the opposite language for mapping
      const oppositeLang = lang === 'en' ? 'zh' : 'en';
      const oppositeResponse = await getCatBreeds(oppositeLang);
      const oppositeBreedsData = oppositeResponse.data.result || [];

      // Create a mapping between the two languages
      const mapping = {};
      breedsData.forEach((breed, index) => {
        if (oppositeBreedsData[index]) {
          mapping[breed] = oppositeBreedsData[index];
          mapping[oppositeBreedsData[index]] = breed;
        }
      });
      setCatBreedsMapping(mapping);
    } catch (err) {
      console.error("Error loading cat breeds:", err);
    }
  };

  // Load all breeds data
  const loadAllBreeds = async (lang) => {
    try {
      setBreedsLoading(true);
      await Promise.all([loadDogBreeds(lang), loadCatBreeds(lang)]);
    } catch (err) {
      console.error("Error loading breeds:", err);
    } finally {
      setBreedsLoading(false);
    }
  };

  // Translate breed when language changes or when breeds are loaded
  useEffect(() => {
    if (basicInfo.breed && basicInfo.animal && !breedsLoading) {
      const currentBreeds = basicInfo.animal === "狗" ? dogBreeds : basicInfo.animal === "貓" ? catBreeds : [];
      const currentMapping = basicInfo.animal === "狗" ? dogBreedsMapping : catBreedsMapping;

      // If the current breed doesn't exist in the current language's options
      if (currentBreeds.length > 0 && !currentBreeds.includes(basicInfo.breed)) {
        // Try to translate it using the mapping
        if (currentMapping[basicInfo.breed]) {
          setBasicInfo(prev => ({
            ...prev,
            breed: currentMapping[basicInfo.breed]
          }));
        } else {
          // If no mapping found, reset to empty to avoid MUI error
          console.warn(`Breed "${basicInfo.breed}" not found in current language. Resetting.`);
        }
      }
    }
  }, [i18n.language, dogBreeds, catBreeds, dogBreedsMapping, catBreedsMapping, breedsLoading]);

  // Load breeds when language changes
  useEffect(() => {
    const lang = i18n.language;
    loadAllBreeds(lang);
  }, [i18n.language]);

  useEffect(() => {
    if (!showFaceID && newPetID) {
      navigate("/pet-management");
    }
  }, [newPetID, showFaceID]);

  // Handle field changes with validation
  const handleFieldChange = (field, value) => {
    setBasicInfo({ ...basicInfo, [field]: value });

    // Real-time validation for specific fields
    if (field === "ownerContact1") {
      const phoneError = validatePetPhoneNumber(value, true);
      setFieldErrors((prev) => ({
        ...prev,
        ownerContact1: phoneError,
      }));
    } else if (field === "ownerContact2") {
      const phoneError = validatePetPhoneNumber(value, false);
      setFieldErrors((prev) => ({
        ...prev,
        ownerContact2: phoneError,
      }));
    } else {
      // Clear error when field is filled
      setFieldErrors((prev) => ({
        ...prev,
        [field]: "",
      }));
    }
  };

  // Fetch pet data if editing
  useEffect(() => {
    if (location.pathname.includes("edit") && petData) {
      setIsEditMode(true);
      setBasicInfo({
        name: petData.name || "",
        birthday: convertFromISO(petData.birthday) || "",
        sex: petData.sex || "",
        sterilization: petData.sterilization ?? "",
        status: petData.status || "",
        animal: petData.animal || "",
        breed: petData.breed || "",
        bloodType: petData.bloodType || "",
        weight: petData.weight || "",
        features: petData.features || "",
        info: petData.info || "",
        owner: petData.owner || "",
        petNumber: petData.petNumber || "",
        ngoId: petData.ngoId || "",
        tagId: petData.tagId || "",
        ownerContact1: petData.ownerContact1 || "",
        ownerContact2: petData.ownerContact2 || "",
        contact1Show: petData.contact1Show || false,
        contact2Show: petData.contact2Show || false,
        receivedDate: convertFromISO(petData.receivedDate) || "",
      });
      setIsToggled(petData.contact1Show || false);
      setIsToggled2(petData.contact2Show || false);
      if (petData.tagId) { setShowPreview(true); }
      if (petData.breedimage && petData.breedimage.length > 0) {
        setImagePreviews(petData.breedimage);
        setExistingImagesCount(petData.breedimage.length);
      } else if (petData.photo) {
        setImagePreviews([petData.photo]);
        setExistingImagesCount(1);
      }
    }
  }, [location, petData]);

  // Fetch medical records when entering edit mode
  useEffect(() => {
    const fetchMedicalRecords = async () => {
      if (location.pathname.includes("edit") && petId) {
        try {
          const [medicalRes, medicationRes, vaccineRes, dewormRes] = await Promise.all([
            getPetMedical(petId).catch(() => ({ data: { form: { medical: [] } } })),
            getPetMedication(petId).catch(() => ({ data: { form: { medication: [] } } })),
            getPetVaccination(petId).catch(() => ({ data: { form: { vaccineRecords: [] } } })),
            getPetDeworming(petId).catch(() => ({ data: { form: { deworm: [] } } }))
          ]);

          setPetData((prevPetData) => ({
            ...prevPetData,
            medical: medicalRes.data.form.medical || [],
            medication: medicationRes.data.form.medication || [],
            vaccineRecords: vaccineRes.data.form.vaccineRecords || [],
            deworm: dewormRes.data.form.deworm || []
          }));
        } catch (error) {
          console.error('Error fetching medical records:', error);
        }
      }
    };

    fetchMedicalRecords();
  }, [location.pathname, petId]);

  const validateForm = () => {
    const errors = {};
    const newDateErrors = {};

    if (!basicInfo.name) errors.name = t('EnterPetName');
    if (!basicInfo.birthday) {
      errors.birthday = t('PleaseEnterDOB');
    } else {
      const dateValidation = validateDate(basicInfo.birthday);
      if (!dateValidation.isValid) {
        newDateErrors.birthday = dateValidation.error;
      }
    }
    if (!basicInfo.sex) errors.sex = t('PleaseSelectGender');
    if (basicInfo.sterilization === null || basicInfo.sterilization === '') errors.sterilization = t('PleaseSelectNeutered');
    if (!basicInfo.animal) errors.animal = t('PleaseSelectAnimal');
    if (!basicInfo.owner) errors.owner = t('PleaseEnterOwner');
    if (!basicInfo.ownerContact1) errors.ownerContact1 = t('PleaseEnterPrimaryContact');

    setFormErrors(errors);
    setDateErrors(newDateErrors);
    return (
      Object.keys(errors).length === 0 &&
      Object.keys(newDateErrors).length === 0 &&
      !fieldErrors.ownerContact1 &&
      !fieldErrors.ownerContact2
    );
  };


  const handleSubmit = async (e) => {
    setButtonLoading(true);
    e.preventDefault();
    basicInfo.contact1Show = isToggled;
    basicInfo.contact2Show = isToggled2;

    // Ensure tagId is set before submit
    if (!basicInfo.tagId && EmbeddedtagId) {
      basicInfo.tagId = EmbeddedtagId;
    }

    if (!validateForm()) {
      setButtonLoading(false); // <-- Add this line
      return;
    }
    if (isEditMode) {
      console.log("Submitting form with data:", basicInfo);
      try {
        //post pet lost/found status update
        if (basicInfo.status === "在家") {
          const deleteReponse = await deletePetLostRecord(petId);
          if (deleteReponse.status === 200) {
            console.log("Pet lost record deleted successfully");
          }
          else {
            setButtonLoading(false);
            setError(true);
            setBackColor("#d32f2f");
            setUpdateMessage(t('ErrorSavingPet'));
            setTimeout(() => {
              setError(false);
            }, 2000);
            return;
          }
        }
        const response = await updatePetImage(basicInfo, petId, removedImageIndices);
        if (response.status === 200) {

          // Refresh pet data
          const petbasicInfo = await getPetBasicInfo(petId);
          setPetData((petData) => ({
            ...petData,
            name: petbasicInfo.data.form.name,
            birthday: convertFromISO(petbasicInfo.data.form.birthday),
            sex: petbasicInfo.data.form.sex,
            sterilization: petbasicInfo.data.form.sterilization,
            status: petbasicInfo.data.form.status,
            animal: petbasicInfo.data.form.animal,
            breed: petbasicInfo.data.form.breed,
            weight: petbasicInfo.data.form.weight,
            features: petbasicInfo.data.form.features,
            info: petbasicInfo.data.form.info,
            owner: petbasicInfo.data.form.owner,
            petNumber: petbasicInfo.data.form.petNumber,
            ngoId: petbasicInfo.data.form.ngoId,
            tagId: petbasicInfo.data.form.tagId,
            ownerContact1: petbasicInfo.data.form.ownerContact1,
            ownerContact2: petbasicInfo.data.form.ownerContact2,
            contact1Show: petbasicInfo.data.form.contact1Show,
            contact2Show: petbasicInfo.data.form.contact2Show,
            receivedDate: convertFromISO(petbasicInfo.data.form.receivedDate),
            breedimage: petbasicInfo.data.form.breedimage,
          }));
          setIsToggled(petbasicInfo.data.form.contact1Show);
          setIsToggled2(petbasicInfo.data.form.contact2Show);
          if (petbasicInfo.data.form.tagId) { setShowPreview(true); }

          // Show success message
          setButtonLoading(false);
          setSuccess(true);
          setShowPreview(true);
          setBackColor("#4CAF50");
          setUpdateMessage(t('PetUpdated'));
          setTimeout(() => {
            setSuccess(false);
          }, 2000);

          //post pet lost/found status update
          if (basicInfo.status === "遺失") {
            setShowPetLost(true);
          }

        } else {
          setButtonLoading(false);
          setError(true);
          setBackColor("#d32f2f");
          setUpdateMessage(t('ErrorSavingPet'));
          setTimeout(() => {
            setError(false);
          }, 2000);
        }
      } catch (error) {
        setButtonLoading(false);
        console.error("Error updating pet:", error);
        setError(true);
        setBackColor("#d32f2f");
        setUpdateMessage(t('ErrorSavingPet'));
        setTimeout(() => {
          setError(false);
        }, 2000);
      }
    } else {
      // Create pet
      try {
        const response = await createPet(id, basicInfo);
        if (response.status === 201) {
          setButtonLoading(false);
          setShowFaceID(true);
          console.log("Pet created successfully:", response);
          setNewPetID(response.data.id);
          //post pet lost/found status update
          if (basicInfo.status === "遺失") {
            setShowPetLost(true);
          }
        } else {
          setButtonLoading(false);
          setError(true);
          setBackColor("#d32f2f");
          setUpdateMessage(t('ErrorCreatingPet'));
          setTimeout(() => {
            setError(false);
          }, 2000);
        }
      } catch (error) {
        setButtonLoading(false);
        console.error("Error creating pet:", error);
        setError(true);
        setBackColor("#d32f2f");
        setUpdateMessage(t('ErrorCreatingPet'));
        setTimeout(() => {
          setError(false);
        }, 2000);
      }
    }
    setFormErrors({});
  };

  // Image compression utility
  const compressImage = async (file) => {
    const fileSizeMB = file.size / (1024 * 1024);

    let quality;
    if (fileSizeMB <= 0.3) {
      quality = 1;
    } else if (fileSizeMB <= 1) {
      quality = 0.5;
    } else if (fileSizeMB <= 2) {
      quality = 0.2;
    } else {
      quality = 0.1;
    }

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event) => {
        const img = new Image();
        img.src = event.target.result;
        img.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = img.width;
          canvas.height = img.height;

          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0);

          canvas.toBlob(
            (blob) => {
              if (blob) {
                const compressedFile = new File([blob], file.name, {
                  type: 'image/jpeg',
                  lastModified: Date.now(),
                });
                console.log(`Compressed ${file.name}: ${fileSizeMB.toFixed(2)}MB → ${(blob.size / (1024 * 1024)).toFixed(2)}MB`);
                resolve(compressedFile);
              } else {
                reject(new Error('Compression failed'));
              }
            },
            'image/jpeg',
            quality
          );
        };
        img.onerror = () => reject(new Error('Failed to load image'));
      };
      reader.onerror = () => reject(new Error('Failed to read file'));
    });
  };

  // Image upload handler - supports multiple images with compression
  const handleImageChange = async (e) => {
    const files = Array.from(e.target.files);
    const newFiles = [];

    for (const file of files) {
      if (file && file.type.startsWith("image/")) {
        try {

          // Reject files larger than 10MB
          if (file.size / (1024 * 1024) > 10) {
            setError(true);
            setBackColor("#d32f2f");
            setUpdateMessage(t('ImageTooLarge'));
            setTimeout(() => {
              setError(false);
            }, 2000);
            continue;
          }

          const compressedFile = await compressImage(file);
          newFiles.push(compressedFile);

          // Create preview
          const reader = new FileReader();
          reader.onloadend = () => {
            setImagePreviews(prev => [...prev, reader.result]);
          };
          reader.readAsDataURL(compressedFile);
        } catch (error) {
          console.error("Error processing image:", error);
          setError(true);
          setBackColor("#d32f2f");
          setUpdateMessage(error.message);
          setTimeout(() => {
            setError(false);
          }, 3000);
          // Skip this file and continue with others
          continue;
        }
      }
    }

    if (newFiles.length > 0) {
      setImageFiles(prev => [...prev, ...newFiles]);
      setBasicInfo({
        ...basicInfo,
        imageFiles: [...(basicInfo.imageFiles || []), ...newFiles], // Store all compressed files for upload
      });
    }
  };

  // Remove image handler
  const handleRemoveImage = (idx) => {
    // Check if this is an existing image from AWS (within the original count)
    if (idx < existingImagesCount) {
      // Track the index of the removed existing image
      setRemovedImageIndices(prev => [...prev, idx]);
    }

    // Remove from previews
    setImagePreviews(prev => prev.filter((_, i) => i !== idx));

    // Remove from new files if it's beyond existing images count
    const newFileIndex = idx - existingImagesCount;
    if (newFileIndex >= 0) {
      setImageFiles(prev => prev.filter((_, i) => i !== newFileIndex));
      setBasicInfo({
        ...basicInfo,
        imageFiles: imageFiles.filter((_, i) => i !== newFileIndex),
      });
    }

    // Adjust existing images count if we removed an existing image
    if (idx < existingImagesCount) {
      setExistingImagesCount(prev => prev - 1);
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: "#FCF8F3",
        minHeight: "100vh",
        pt: isMobile ? 12 : 16,
      }}
    >
      <Navbar />
      <Box
        sx={{
          maxWidth: 1440,
          mx: "auto",
          mb: { xs: 5, md: 10 },
          px: { xs: 2, sm: 3, md: 0 },
        }}
      >
        {/* Header */}
        <PetFormHeader
          currentPageId="basic"
          isEditMode={isEditMode}
          petId={isEditMode ? petId : null}
          petData={isEditMode ? petData : null}
          handlePageNavigation={() => { }}
        />
        <Box component="form" onSubmit={handleSubmit}>
          <Typography
            variant="h6"
            fontWeight="bold"
            sx={{ mt: 3, mb: 1, fontSize: isMobile ? 16 : 20, px: 3, pb: 2 }}
          >
            {t('BasicInfo')}
          </Typography>
          <Grid container justifyContent="space-between" sx={{ px: 3 }}>
            {/* First Column - Basic Info and Photo */}
            <Grid item xs={12} md={4}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 3, minWidth: isMobile ? 310 : 400 }}>
                {/* Name */}
                <Box>
                  <Label htmlFor="name" sx={{ display: "block", mb: 1, }}>
                    {t('Name')}
                    <span style={{ color: "red", marginLeft: 4 }}>*</span>
                  </Label>
                  <TextField
                    id="name"
                    name="name"
                    placeholder={t('Name')}
                    value={basicInfo.name || ""}
                    onChange={(e) => {
                      setBasicInfo({ ...basicInfo, name: e.target.value });
                      setFormErrors({ ...formErrors, name: "" });
                    }}
                    required
                    fullWidth
                    variant="outlined"
                    sx={{
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "white",
                      },
                    }}
                  />
                  {formErrors.name && (
                    <Typography color="error" variant="caption">
                      {formErrors.name}
                    </Typography>
                  )}
                </Box>
                {/* Breed Image */}
                <Box sx={{ flexGrow: 1 }}>
                  <Label sx={{ display: "block", mb: 1 }}>{t('Photos5')}</Label>
                  <Box
                    sx={{
                      border: 1,
                      borderColor: "grey.300",
                      borderRadius: 1,
                      p: 4,
                      display: "flex",
                      flexDirection: "row",
                      flexWrap: "wrap",
                      alignItems: imagePreviews.length > 0 ? "flex-start" : "center",
                      justifyContent: imagePreviews.length > 0 ? "flex-start" : "center",
                      gap: 2,
                      minHeight: isMobile ? 300 : 400,
                      width: isMobile ? 310 : 400,
                      backgroundColor: "white",
                      position: "relative",
                    }}
                  >
                    {imagePreviews.length > 0 ? (
                      imagePreviews.map((preview, idx) => (
                        <Box key={idx} sx={{ position: "relative" }}>
                          <img
                            src={preview}
                            alt={`預覽圖片${idx + 1}`}
                            style={{
                              maxWidth: 100,
                              maxHeight: 100,
                              marginBottom: 8,
                              borderRadius: 8,
                              objectFit: "cover",
                            }}
                            onError={(e) => {
                              console.error(`Image failed to load at index ${idx}:`, preview);
                              console.error('Error event:', e);
                            }}

                          />
                          <IconButton
                            size="small"
                            sx={{
                              position: "absolute",
                              top: -10,
                              right: -10,
                              background: "rgba(66, 66, 66, 0.7)",
                              zIndex: 2,
                              width: 24,
                              height: 24,
                              "&:hover": {
                                background: "rgba(66, 66, 66, 0.9)",
                              },
                            }}
                            onClick={() => handleRemoveImage(idx)}
                          >
                            <CloseIcon size={16} color="white" />
                          </IconButton>
                        </Box>
                      ))
                    ) : (
                      <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect width="25" height="25" rx="12.5" fill="#FFF0CD" />
                        <path d="M12.5 8.33594V16.6693" stroke="#FFB60C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M8.33203 12.5H16.6654" stroke="#FFB60C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    )}
                    {imagePreviews.length > 0 && imagePreviews.length < 5 && (
                      <Box sx={{
                        width: 100,
                        height: 100,
                        marginBottom: 8,
                        borderRadius: 1,
                        border: "2px dashed #C4C4C4",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}>
                        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect width="25" height="25" rx="12.5" fill="#FFF0CD" />
                          <path d="M12.5 8.33594V16.6693" stroke="#FFB60C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          <path d="M8.33203 12.5H16.6654" stroke="#FFB60C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </Box>
                    )}
                    {imagePreviews.length < 5 && (
                      <input
                        type="file"
                        accept="image/*"
                        multiple
                        style={{
                          position: "absolute",
                          width: "100%",
                          height: "100%",
                          opacity: 0,
                          left: 0,
                          top: 0,
                          cursor: "pointer",
                        }}
                        onChange={handleImageChange}
                      />
                    )}
                  </Box>
                  <Typography
                    variant="body2"
                    color="textSecondary"
                    sx={{ mt: 1, textAlign: "left", width: isMobile ? 300 : 400 }}
                  >
                    {t('photoInfo')}

                  </Typography>
                </Box>
              </Box>
            </Grid>
            {/* Second Column - Pet Information */}
            <Grid item xs={12} md={4}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 3, minWidth: isMobile ? 310 : 400, }}>
                {/* Birthday */}
                <Box>
                  <Label htmlFor="birthday" sx={{ display: "block", mb: 1 }}>
                    {t('DateofBirth')}
                    <span style={{ color: "red", marginLeft: 4 }}>*</span>
                  </Label>
                  <DatePickerField
                    id="birthday"
                    name="birthday"
                    placeholder="DD/MM/YYYY"
                    value={basicInfo.birthday || ""}
                    onChange={(value) => {
                      setBasicInfo({ ...basicInfo, birthday: value });
                      setFormErrors({ ...formErrors, birthday: "" });
                    }}
                    onError={(error) =>
                      setDateErrors({ ...dateErrors, birthday: error })
                    }
                    required
                  />
                  {formErrors.birthday && (
                    <Typography color="error" variant="caption">
                      {formErrors.birthday}
                    </Typography>
                  )}
                </Box>
                {/* Sex */}
                <Box>
                  <FormLabel component="legend" sx={{ mb: 1 }}>
                    {t('Gender')}
                    <span style={{ color: "red", marginLeft: 4 }}>*</span>
                  </FormLabel>
                  <RadioGroup
                    name="sex"
                    value={basicInfo.sex === "male" ? "男" : basicInfo.sex === "female" ? "女" : ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      setBasicInfo({
                        ...basicInfo,
                        sex: value === "男" ? "male" : value === "女" ? "female" : "",
                      });
                      setFormErrors({ ...formErrors, sex: "" });
                    }}
                    row
                  >
                    <FormControlLabel
                      value="男"
                      sx={{
                        width: 130,
                      }}
                      control={<Radio />}
                      label={t('male')}
                    />
                    <FormControlLabel
                      value="女"
                      control={<Radio />}
                      label={t('female')}
                    />
                  </RadioGroup>
                  {formErrors.sex && (
                    <Typography color="error" variant="caption">
                      {formErrors.sex}
                    </Typography>
                  )}
                </Box>
                {/* Sterilization */}
                <Box>
                  <FormLabel component="legend" sx={{ mb: 1 }}>
                    {t('Neutered')}
                    <span style={{ color: "red", marginLeft: 4 }}>*</span>
                  </FormLabel>
                  <RadioGroup
                    name="sterilization"
                    value={basicInfo.sterilization === true ? "是" : basicInfo.sterilization === false && "否"}
                    onChange={(e) => {
                      setBasicInfo({
                        ...basicInfo,
                        sterilization: e.target.value === "是" ? true : e.target.value === "否" && false,
                      });
                      setFormErrors({ ...formErrors, sterilization: "" });
                    }}
                    row
                  >
                    <FormControlLabel
                      value="是"
                      sx={{
                        width: 130,
                      }}
                      control={<Radio />}
                      label={t('Yes')}
                    />
                    <FormControlLabel
                      value="否"
                      control={<Radio />}
                      label={t('No')}
                    />
                  </RadioGroup>
                  {formErrors.sterilization && (
                    <Typography color="error" variant="caption">
                      {formErrors.sterilization}
                    </Typography>
                  )}
                </Box>
                {/* Status */}
                <Box>
                  <FormLabel component="legend" sx={{ mb: 1 }}>
                    {t('Status')}
                  </FormLabel>
                  <RadioGroup
                    name="status"
                    value={basicInfo.status}
                    onChange={(e) =>
                      setBasicInfo({ ...basicInfo, status: e.target.value })
                    }
                    row
                  >
                    <FormControlLabel
                      value="在家"
                      sx={{
                        width: 130,
                      }}
                      control={<Radio />}
                      label={t('AtHome')}
                    />
                    <FormControlLabel
                      value="遺失"
                      control={<Radio />}
                      label={t('Lost')}
                    />
                  </RadioGroup>
                </Box>
                {/* Animal */}
                <Box>
                  <Label htmlFor="animal" sx={{ display: "block", mb: 1 }}>
                    {t('Species')}
                    <span style={{ color: "red", marginLeft: 4 }}>*</span>
                  </Label>
                  <FormControl fullWidth error={!!formErrors.animal}>
                    <Select
                      id="animal"
                      name="animal"
                      value={basicInfo.animal}
                      onChange={(e) => {
                        setBasicInfo({ ...basicInfo, animal: e.target.value, bloodType: "" });
                        setFormErrors({ ...formErrors, animal: "" });
                      }}
                      displayEmpty
                      sx={{
                        backgroundColor: "white",
                        "& .MuiOutlinedInput-root": {
                          backgroundColor: "white",
                        },
                      }}
                      MenuProps={{
                        disableScrollLock: true
                      }}
                    >
                      <MenuItem value="" disabled>
                        {t('PleaseSelect')}
                      </MenuItem>
                      <MenuItem value="狗">{t('dog')}</MenuItem>
                      <MenuItem value="貓">{t('cat')}</MenuItem>
                      <MenuItem value="兔">{t('Rabbit')}</MenuItem>
                      <MenuItem value="其他">{t('other')}</MenuItem>
                    </Select>
                    {formErrors.animal && (
                      <Typography color="error" variant="caption">
                        {formErrors.animal}
                      </Typography>
                    )}
                  </FormControl>
                </Box>
                {/* Blood Type */}
                <Box>
                  <Label htmlFor="bloodType" sx={{ display: "block", mb: 1 }}>
                    {t('BloodType')}
                  </Label>
                  {!basicInfo.animal && (
                    <FormControl fullWidth>
                      <Select
                        id="bloodType"
                        name="bloodType"
                        value={basicInfo.bloodType}
                        onChange={(e) => {
                          setBasicInfo({ ...basicInfo, bloodType: e.target.value });
                        }}
                        displayEmpty
                        disabled={!basicInfo.animal}
                        sx={{
                          backgroundColor: "white",
                          "& .MuiOutlinedInput-root": {
                            backgroundColor: "white",
                          },
                        }}
                        MenuProps={{
                          disableScrollLock: true
                        }}
                      >
                        <MenuItem value="" disabled>{t('PleaseSelect')}</MenuItem>
                      </Select>
                    </FormControl>
                  )}
                  {basicInfo.animal === "狗" && (
                    <FormControl fullWidth>
                      <Select
                        id="bloodType"
                        name="bloodType"
                        value={basicInfo.bloodType}
                        onChange={(e) => {
                          setBasicInfo({ ...basicInfo, bloodType: e.target.value });
                        }}
                        displayEmpty
                        disabled={!basicInfo.animal}
                        sx={{
                          backgroundColor: "white",
                          "& .MuiOutlinedInput-root": {
                            backgroundColor: "white",
                          },
                        }}
                        MenuProps={{
                          disableScrollLock: true
                        }}
                      >
                        <MenuItem value="" disabled>{t('PleaseSelect')}</MenuItem>
                        <MenuItem value="Positive">{t('Positive')}</MenuItem>
                        <MenuItem value="Negative">{t('Negative')}</MenuItem>
                      </Select>
                    </FormControl>
                  )}
                  {basicInfo.animal === "貓" && (
                    <FormControl fullWidth>
                      <Select
                        id="bloodType"
                        name="bloodType"
                        value={basicInfo.bloodType}
                        onChange={(e) => {
                          setBasicInfo({ ...basicInfo, bloodType: e.target.value });
                        }}
                        displayEmpty
                        disabled={!basicInfo.animal}
                        sx={{
                          backgroundColor: "white",
                          "& .MuiOutlinedInput-root": {
                            backgroundColor: "white",
                          },
                        }}
                        MenuProps={{
                          disableScrollLock: true
                        }}
                      >
                        <MenuItem value="" disabled>{t('PleaseSelect')}</MenuItem>
                        <MenuItem value="Group A">{t('GroupA')}</MenuItem>
                        <MenuItem value="Group B">{t('GroupB')}</MenuItem>
                        <MenuItem value="Group AB">{t('GroupAB')}</MenuItem>
                      </Select>
                    </FormControl>
                  )}
                  {basicInfo.animal === "兔" && (
                    <FormControl fullWidth>
                      <Select
                        id="bloodType"
                        name="bloodType"
                        value={basicInfo.bloodType}
                        onChange={(e) => {
                          setBasicInfo({ ...basicInfo, bloodType: e.target.value });
                        }}
                        displayEmpty
                        disabled={!basicInfo.animal}
                        sx={{
                          backgroundColor: "white",
                          "& .MuiOutlinedInput-root": {
                            backgroundColor: "white",
                          },
                        }}
                        MenuProps={{
                          disableScrollLock: true
                        }}
                      >
                        <MenuItem value="" disabled>{t('PleaseSelect')}</MenuItem>
                        <MenuItem value="Other Group">{t('OtherGroup')}</MenuItem>
                      </Select>
                    </FormControl>
                  )}
                  {basicInfo.animal === "其他" && (
                    <FormControl fullWidth>
                      <Select
                        id="bloodType"
                        name="bloodType"
                        value={basicInfo.bloodType}
                        onChange={(e) => {
                          setBasicInfo({ ...basicInfo, bloodType: e.target.value });
                        }}
                        displayEmpty
                        disabled={!basicInfo.animal}
                        sx={{
                          backgroundColor: "white",
                          "& .MuiOutlinedInput-root": {
                            backgroundColor: "white",
                          },
                        }}
                        MenuProps={{
                          disableScrollLock: true
                        }}
                      >
                        <MenuItem value="" disabled>{t('PleaseSelect')}</MenuItem>
                        <MenuItem value="Not Tested">{t('OtherGroup')}</MenuItem>
                      </Select>
                    </FormControl>
                  )}
                </Box>
                {/* Breed */}
                <Box>
                  {basicInfo.animal !== "其他" && basicInfo.animal !== "兔" && (
                    <>
                      <Label htmlFor="breed" sx={{ display: "block", mb: 1 }}>
                        {t('breed')}
                      </Label>
                      <FormControl fullWidth>
                        <Select
                          id="breed"
                          name="breed"
                          value={(() => {
                            // Determine current breed list based on animal type
                            const currentBreeds = basicInfo.animal === "狗" ? dogBreeds :
                              basicInfo.animal === "貓" ? catBreeds : [];

                            // If breed exists in current options, use it
                            if (currentBreeds.includes(basicInfo.breed)) {
                              return basicInfo.breed;
                            }

                            // If no breed or doesn't exist in options, return empty
                            return "";
                          })()}
                          onChange={(e) =>
                            setBasicInfo({ ...basicInfo, breed: e.target.value })
                          }
                          displayEmpty
                          disabled={!basicInfo.animal}
                          sx={{
                            backgroundColor: "white",

                          }}
                          MenuProps={{
                            disableScrollLock: true
                          }}
                        >
                          <MenuItem value="" disabled>
                            {t('PleaseSelect')}
                          </MenuItem>
                          {basicInfo.animal === "狗" &&

                            dogBreeds.map((breed) => (
                              <MenuItem key={breed} value={breed}>
                                {breed}
                              </MenuItem>
                            ))}
                          {basicInfo.animal === "貓" &&
                            catBreeds.map((breed) => (
                              <MenuItem key={breed} value={breed}>
                                {breed}
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                    </>
                  )}
                </Box>
              </Box>
            </Grid>
            {/* Third Column - More Pet Information */}
            <Grid item xs={12} md={4}>
              <Box sx={{ display: "flex", flexDirection: "column", gap: 3, minWidth: isMobile ? 310 : 400, }}>
                {/* Weight */}
                <Box>
                  <Label htmlFor="weight" sx={{ display: "block", mb: 1 }}>
                    {t('weight')}
                  </Label>
                  <TextField
                    id="weight"
                    name="weight"
                    placeholder={t('kg')}
                    type="number"
                    inputProps={{ min: 0, step: 0.1 }}
                    value={basicInfo.weight || ""}
                    onChange={(e) =>
                      setBasicInfo({ ...basicInfo, weight: e.target.value })
                    }
                    fullWidth
                    variant="outlined"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">KG</InputAdornment>
                      ),
                    }}
                    sx={{
                      backgroundColor: "white",
                      "& .MuiOutlinedInput-root": {
                        backgroundColor: "white",
                      },
                    }}
                  />
                </Box>
                {/* Features */}
                <Box>
                  <Label htmlFor="features" sx={{ display: "block", mb: 1 }}>
                    {t('Features')}
                  </Label>
                  <Textarea
                    id="features"
                    name="features"
                    placeholder={t("FeaturesInfo")}
                    value={basicInfo.features || ""}
                    onChange={(e) =>
                      setBasicInfo({ ...basicInfo, features: e.target.value })
                    }
                    rows={4}
                  />
                </Box>
                {/* Info */}
                <Box sx={{ flexGrow: 1 }}>
                  <Label htmlFor="info" sx={{ display: "block", mb: 1 }}>
                    {t('OtherInfo')}
                  </Label>
                  <Textarea
                    id="info"
                    name="info"
                    placeholder={t('OtherInfoHelp')}
                    value={basicInfo.info || ""}
                    onChange={(e) =>
                      setBasicInfo({ ...basicInfo, info: e.target.value })
                    }
                    sx={{ backgroundColor: "white" }}
                    rows={6}
                  />
                </Box>
                <Box>
                  <Label htmlFor="tagId" sx={{ display: "block", mb: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Box>{t('PetID')}</Box>
                    {(basicInfo.tagId && showPreview) && <Button sx={{
                      cursor: 'pointer', textTransform: 'none',
                      color: "#050505",
                      borderRadius: 2,
                      textAlign: "center",
                      "&:hover": { backgroundColor: "#e0e0e0" },
                    }}
                      onClick={() => { navigate(`/pet_info?qr=${basicInfo.tagId}&petId=${petData._id}`, { state: { petData } }); }}>
                      {t('Preview')}
                    </Button>}
                  </Label>
                  <TextField
                    id="tagId"
                    name="tagId"
                    placeholder={t('PetID')}
                    value={basicInfo.tagId || EmbeddedtagId}
                    disabled
                    fullWidth
                    variant="outlined"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          {!!basicInfo.tagId ? <IconButton
                            size="small"
                            onClick={() => {
                              setDetachTag(true);
                            }}
                            sx={{
                              padding: 1,
                              '&:hover': {
                                backgroundColor: '#e0e0e0',
                              },
                              cursor: 'pointer',
                            }}
                          >
                            <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M8.48026 8.48071C9.46299 7.49805 10.7858 6.9307 12.1751 6.89602C13.5644 6.86134 14.9139 7.36198 15.9444 8.29437L16.1405 8.48071L19.2042 11.5455C20.202 12.545 20.7699 13.8948 20.7869 15.307C20.8039 16.7192 20.2687 18.0823 19.2952 19.1056C18.3218 20.1288 16.9872 20.7315 15.5759 20.785C14.1645 20.8385 12.7881 20.3387 11.74 19.392L11.545 19.2057L9.24618 16.9069C9.05188 16.7119 8.93908 16.4503 8.93068 16.1752C8.92228 15.9001 9.01891 15.6321 9.20095 15.4257C9.38298 15.2192 9.63678 15.0898 9.91077 15.0637C10.1848 15.0376 10.4584 15.1168 10.6762 15.2851L10.778 15.375L13.0768 17.6739C13.6728 18.2733 14.4787 18.6169 15.3238 18.632C16.1689 18.647 16.9866 18.3322 17.6034 17.7544C18.2203 17.1766 18.5878 16.3812 18.6279 15.5369C18.6681 14.6927 18.3778 13.866 17.8186 13.2322L17.6723 13.0773L14.6087 10.0136C14.3069 9.71177 13.9486 9.47233 13.5542 9.30897C13.1599 9.14561 12.7372 9.06152 12.3104 9.06152C11.8835 9.06152 11.4609 9.14561 11.0665 9.30897C10.6722 9.47233 10.3139 9.71177 10.0121 10.0136C9.80882 10.2168 9.53317 10.3308 9.24579 10.3307C8.95842 10.3306 8.68285 10.2164 8.47972 10.0131C8.27658 9.8098 8.16252 9.53416 8.16262 9.24678C8.16272 8.9594 8.27698 8.68384 8.48026 8.48071ZM6.06226 15.8138C6.3276 15.8138 6.58371 15.9112 6.782 16.0876C6.98028 16.2639 7.10696 16.5068 7.13801 16.7704L7.14559 16.8971V19.0638C7.14529 19.3399 7.03956 19.6055 6.85001 19.8063C6.66046 20.0071 6.40139 20.1279 6.12575 20.1441C5.8501 20.1602 5.57868 20.0706 5.36694 19.8933C5.1552 19.7161 5.01912 19.4647 4.98651 19.1905L4.97893 19.0638V16.8971C4.97893 16.6098 5.09306 16.3343 5.29623 16.1311C5.49939 15.9279 5.77494 15.8138 6.06226 15.8138ZM2.81226 13.6471C3.08838 13.6474 3.35396 13.7532 3.55474 13.9427C3.75552 14.1323 3.87635 14.3913 3.89253 14.667C3.90871 14.9426 3.81903 15.214 3.64181 15.4258C3.46458 15.6375 3.2132 15.7736 2.93901 15.8062L2.81226 15.8138H1.72893C1.45281 15.8135 1.18723 15.7078 0.986444 15.5182C0.785664 15.3287 0.664839 15.0696 0.648657 14.7939C0.632475 14.5183 0.722157 14.2469 0.89938 14.0351C1.0766 13.8234 1.32799 13.6873 1.60218 13.6547L1.72893 13.6471H2.81226ZM1.58593 1.58637C2.56865 0.603717 3.89147 0.0363709 5.28078 0.00168878C6.67008 -0.0329934 8.01956 0.467641 9.05009 1.40004L9.24618 1.58637L11.5439 3.88629C11.7382 4.08124 11.851 4.34284 11.8594 4.61796C11.8678 4.89307 11.7712 5.16106 11.5892 5.36751C11.4071 5.57395 11.1533 5.70337 10.8793 5.72947C10.6053 5.75557 10.3317 5.6764 10.1139 5.50804L10.0121 5.41812L7.71434 3.12037C7.11739 2.52731 6.31369 2.1889 5.47232 2.17633C4.63094 2.16376 3.81749 2.47801 3.20309 3.05298C2.58869 3.62794 2.22124 4.41879 2.17805 5.25915C2.13486 6.09951 2.41929 6.92387 2.97151 7.55879L3.11776 7.71479L6.18251 10.7795C6.79198 11.3888 7.61848 11.7311 8.48026 11.7311C9.34204 11.7311 10.1685 11.3888 10.778 10.7795C10.8786 10.6789 10.998 10.599 11.1295 10.5445C11.2609 10.49 11.4018 10.462 11.5441 10.4619C11.6864 10.4619 11.8273 10.4898 11.9588 10.5442C12.0903 10.5986 12.2097 10.6784 12.3104 10.779C12.411 10.8796 12.4909 10.999 12.5454 11.1304C12.5999 11.2619 12.628 11.4028 12.628 11.5451C12.6281 11.6874 12.6001 11.8283 12.5457 11.9598C12.4913 12.0912 12.4115 12.2107 12.3109 12.3114C11.3282 13.294 10.0054 13.8614 8.61608 13.8961C7.22678 13.9307 5.87729 13.4301 4.84676 12.4977L4.64959 12.3114L1.58593 9.24662C0.570458 8.23085 0 6.85335 0 5.41704C0 3.98073 0.570458 2.60215 1.58593 1.58637ZM19.0623 4.98046C19.3496 4.98046 19.6251 5.09459 19.8283 5.29776C20.0315 5.50092 20.1456 5.77647 20.1456 6.06379C20.1456 6.35111 20.0315 6.62666 19.8283 6.82982C19.6251 7.03299 19.3496 7.14712 19.0623 7.14712H17.9789C17.6916 7.14712 17.4161 7.03299 17.2129 6.82982C17.0097 6.62666 16.8956 6.35111 16.8956 6.06379C16.8956 5.77647 17.0097 5.50092 17.2129 5.29776C17.4161 5.09459 17.6916 4.98046 17.9789 4.98046H19.0623ZM14.7289 0.647123C14.9943 0.647157 15.2504 0.744575 15.4487 0.920897C15.647 1.09722 15.7736 1.34018 15.8047 1.60371L15.8123 1.73046V3.89712C15.812 4.17324 15.7062 4.43882 15.5167 4.63961C15.3271 4.84039 15.0681 4.96121 14.7924 4.97739C14.5168 4.99357 14.2453 4.90389 14.0336 4.72667C13.8219 4.54945 13.6858 4.29806 13.6532 4.02387L13.6456 3.89712V1.73046C13.6456 1.44314 13.7597 1.16759 13.9629 0.964423C14.1661 0.761259 14.4416 0.647123 14.7289 0.647123Z" fill="black" />
                            </svg>
                          </IconButton> : <IconButton
                            size="small"
                            onClick={() => {
                              setEmbedTag(true);
                            }}
                            sx={{
                              padding: 1,
                              '&:hover': {
                                backgroundColor: '#e0e0e0',
                              },
                              cursor: 'pointer',
                            }}
                          >

                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M8.1541 8.15452C9.09902 7.20966 10.371 6.66414 11.7068 6.63079C13.0427 6.59744 14.3403 7.07882 15.3312 7.97536L15.5197 8.15452L18.4656 11.1014C19.425 12.0625 19.971 13.3603 19.9874 14.7183C20.0038 16.0762 19.4891 17.3868 18.5531 18.3707C17.6171 19.3547 16.3338 19.9341 14.9768 19.9856C13.6198 20.037 12.2963 19.5564 11.2885 18.6462L11.101 18.467L8.89055 16.2566C8.70373 16.0692 8.59527 15.8176 8.58719 15.5531C8.57911 15.2886 8.67203 15.0309 8.84706 14.8324C9.0221 14.6339 9.26613 14.5094 9.52959 14.4843C9.79305 14.4592 10.0562 14.5353 10.2656 14.6972L10.3635 14.7837L12.5739 16.9941C13.1469 17.5704 13.9219 17.9009 14.7344 17.9153C15.547 17.9298 16.3332 17.6271 16.9264 17.0715C17.5195 16.5159 17.8729 15.7511 17.9115 14.9394C17.9501 14.1276 17.671 13.3327 17.1333 12.7233L16.9926 12.5743L14.0468 9.62848C13.7566 9.33824 13.4121 9.10801 13.0329 8.95093C12.6537 8.79385 12.2473 8.713 11.8369 8.713C11.4265 8.713 11.0201 8.79385 10.6409 8.95093C10.2617 9.10801 9.9172 9.33824 9.62701 9.62848C9.43155 9.8238 9.16651 9.93348 8.89019 9.93338C8.61386 9.93328 8.3489 9.82342 8.15357 9.62796C7.95825 9.4325 7.84858 9.16746 7.84868 8.89114C7.84877 8.61481 7.95864 8.34985 8.1541 8.15452ZM1.52493 1.52536C2.46986 0.580497 3.7418 0.034972 5.07767 0.00162382C6.41354 -0.0317244 7.71112 0.449655 8.70201 1.34619L8.89055 1.52536L11.0999 3.73682C11.2867 3.92427 11.3952 4.17581 11.4033 4.44034C11.4114 4.70487 11.3185 4.96256 11.1434 5.16107C10.9684 5.35957 10.7244 5.48401 10.4609 5.50911C10.1974 5.5342 9.93429 5.45808 9.72493 5.29619L9.62701 5.20973L7.41764 3.00036C6.84365 2.43011 6.07086 2.10471 5.26184 2.09262C4.45283 2.08054 3.67066 2.3827 3.07989 2.93555C2.48912 3.4884 2.13581 4.24884 2.09428 5.05688C2.05275 5.86491 2.32624 6.65756 2.85722 7.26807L2.99785 7.41807L5.94472 10.3649C6.53074 10.9508 7.32546 11.2799 8.1541 11.2799C8.98273 11.2799 9.77745 10.9508 10.3635 10.3649C10.4602 10.2682 10.575 10.1914 10.7014 10.139C10.8278 10.0866 10.9633 10.0596 11.1001 10.0595C11.2369 10.0595 11.3724 10.0864 11.4988 10.1387C11.6252 10.191 11.7401 10.2677 11.8369 10.3644C11.9337 10.4611 12.0105 10.576 12.0629 10.7023C12.1153 10.8287 12.1423 10.9642 12.1423 11.101C12.1424 11.2379 12.1155 11.3733 12.0632 11.4998C12.0108 11.6262 11.9341 11.7411 11.8374 11.8379C10.8925 12.7827 9.62055 13.3282 8.28469 13.3616C6.94882 13.3949 5.65124 12.9136 4.66035 12.017L4.47076 11.8379L1.52493 8.89098C0.548518 7.91428 0 6.58975 0 5.20869C0 3.82763 0.548518 2.50206 1.52493 1.52536Z" fill="black" />
                            </svg>
                          </IconButton>}

                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      backgroundColor: "white",
                      "&.Mui-disabled": {
                        backgroundColor: "#e0e0e0",
                      },
                      "& .MuiOutlinedInput-root.Mui-disabled": {
                        backgroundColor: "#e0e0e0",
                      },
                    }}
                  />
                </Box>
              </Box>
            </Grid>
          </Grid>

          {/* Owner Info Section */}
          <Box sx={{ mt: 6, mb: 2, px: 3 }}>
            <Typography
              variant="h6"
              fontWeight={700}
              sx={{ mb: 2, color: "#050505" }}
            >
              {t('ContactInfo')}
            </Typography>
            <Grid container spacing={3} justifyContent="space-between">
              {/* 聯絡人 */}
              <Grid item xs={12} md={4}>
                <Label htmlFor="owner" sx={{ display: "block", mb: 2, mt: 1 }}>
                  {t('ContactPerson')}<span style={{ color: "red", marginLeft: 4 }}>*</span>
                </Label>
                <TextField
                  id="owner"
                  name="owner"
                  placeholder={t('ContactPerson')}
                  value={basicInfo.owner}
                  onChange={(e) => {
                    setBasicInfo({ ...basicInfo, owner: e.target.value });
                    setFormErrors({ ...formErrors, owner: "" });
                  }}
                  required
                  fullWidth
                  variant="outlined"
                  error={!!formErrors.owner}
                  helperText={formErrors.owner}
                  sx={{
                    width: isMobile ? 310 : 400,
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "white",
                    },
                    "& .MuiFormHelperText-root.Mui-error": {
                      marginLeft: 0,
                    },
                  }}
                />
              </Grid>
              {/* 主要聯絡電話 */}
              <Grid item xs={12} md={4}>
                <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                  <Label htmlFor="ownerContact1">
                    {t('ContactPhone')}
                    <span style={{ color: "red", marginLeft: 4 }}>*</span>
                  </Label>
                  <Typography
                    variant="h6"
                    sx={{
                      paddingLeft: "10px",
                      fontSize: { xs: "10px", md: "12px" },
                      fontWeight: "400",
                      display: "inline",
                      color: "#969696",
                    }}
                  >
                    {t('displayAsk')}
                  </Typography>
                  <FormControlLabel
                    label=""
                    control={
                      <Switch
                        sx={{
                          "& .MuiSwitch-switchBase": {
                            color: "white", // Thumb color when unchecked
                            "&.Mui-checked": {
                              color: "#FFB60C", // Thumb color when checked
                            },
                          },
                          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                            backgroundColor: "#FFB60C", // Ensure track color when checked
                          },
                          transform: isMobile ? "scale(0.8)" : "scale(1)",
                        }}
                        checked={isToggled}
                        onChange={handleToggleChange}
                        color="primary"
                      />
                    }
                    sx={{ m: 0 }} // Remove default margin
                  />
                </Box>
                <TextField
                  id="ownerContact1"
                  name="ownerContact1"
                  placeholder={t('ContactPhone')}
                  value={basicInfo.ownerContact1}
                  onChange={(e) => {
                    handleFieldChange("ownerContact1", e.target.value);
                    setFormErrors({ ...formErrors, ownerContact1: "" });
                  }}
                  fullWidth
                  variant="outlined"
                  error={
                    !!formErrors.ownerContact1 || !!fieldErrors.ownerContact1
                  }
                  helperText={
                    formErrors.ownerContact1 || fieldErrors.ownerContact1
                  }
                  inputProps={{
                    inputMode: "numeric",
                    pattern: "[0-9]*",
                  }}
                  sx={{
                    width: isMobile ? 310 : 400,
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "white",
                    },
                    "& .MuiFormHelperText-root.Mui-error": {
                      marginLeft: 0,
                    },
                  }}
                />
              </Grid>
              {/* 其他聯絡電話 */}
              <Grid item xs={12} md={4}>
                <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                  <Label htmlFor="ownerContact2" >
                    {t('OtherContact')}
                  </Label>
                  <Typography
                    variant="h6"
                    sx={{
                      paddingLeft: "20px",
                      fontSize: { xs: "10px", md: "12px" },
                      fontWeight: "400",
                      display: "inline",
                      color: "#969696",
                    }}
                  >
                    {t('displayAsk')}
                  </Typography>
                  <FormControlLabel
                    label=""
                    control={
                      <Switch
                        sx={{
                          "& .MuiSwitch-switchBase": {
                            color: "white", // Thumb color when unchecked
                            "&.Mui-checked": {
                              color: "#FFB60C", // Thumb color when checked
                            },
                          },
                          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                            backgroundColor: "#FFB60C", // Ensure track color when checked
                          },
                          transform: isMobile ? "scale(0.8)" : "scale(1)",
                        }}
                        checked={isToggled2}
                        onChange={handleToggleChange2}
                        color="primary"
                      />
                    }
                    sx={{ m: 0 }} // Remove default margin
                  />
                </Box>
                <TextField
                  id="ownerContact2"
                  name="ownerContact2"
                  placeholder={t('OtherContact')}
                  value={basicInfo.ownerContact2}
                  onChange={(e) =>
                    handleFieldChange("ownerContact2", e.target.value)
                  }
                  fullWidth
                  variant="outlined"
                  error={!!fieldErrors.ownerContact2}
                  helperText={fieldErrors.ownerContact2}
                  inputProps={{
                    inputMode: "numeric",
                    pattern: "[0-9]*",
                  }}
                  sx={{
                    width: isMobile ? 310 : 400,
                    backgroundColor: "white",
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "white",
                    },
                  }}
                />
              </Grid>
            </Grid>
          </Box>

          {/* Bottom Buttons */}
          {isEditMode ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                justifyContent: { xs: "center", md: "flex-end" },
                mt: { xs: 5, md: 10 },
                mx: 3,
                gap: 2,
              }}
            >
              <Button
                type="submit"
                variant="contained"
                disabled={buttonLoading}
                sx={{
                  backgroundColor: "#FFB60C",
                  color: "#050505",
                  minWidth: 120,
                  "&:hover": { backgroundColor: "#FFB60C" },
                  "&:disabled": { background: "rgba(255, 182, 12, 0.5)" },
                  cursor: buttonLoading ? "not-allowed" : "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "10px",

                }}
                onClick={handleSubmit}
              >
                {t('Save')}
                {buttonLoading && (
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                    }}
                  >
                    <CircularProgress size={15} color="inherit" />
                  </span>
                )}
              </Button>
              <Button
                type="button"
                variant="outlined"
                color="text.secondary"
                onClick={() => navigate("/pet-management")}
                sx={{
                  minWidth: 120,
                  "&:hover": {
                    backgroundColor: "black",
                    color: "white",
                  },
                }}
              >
                {t('cancel')}
              </Button>
            </Box>
          ) : (
            <Box
              sx={{
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                justifyContent: { xs: "center", md: "flex-end" },
                alignItems: isMobile ? "stretch" : "center",
                mt: { xs: 5, md: 10 },
                mx: 3,
                gap: 2,
              }}
            >
              <Button
                type="submit"
                variant="contained"
                disabled={buttonLoading}
                sx={{
                  backgroundColor: "#FFB60C",
                  color: "#050505",
                  minWidth: 120,
                  "&:hover": { backgroundColor: "#FFB60C" },
                  "&:disabled": { background: "rgba(255, 182, 12, 0.5)" },
                  cursor: buttonLoading ? "not-allowed" : "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "10px",
                }}
                onClick={handleSubmit}
              >
                {t('Save')}
                {buttonLoading && (
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                    }}
                  >
                    <CircularProgress size={15} color="inherit" />
                  </span>
                )}
              </Button>
              <Button
                type="button"
                variant="outlined"
                color="text.secondary"
                sx={{
                  minWidth: 120,
                  "&:hover": {
                    backgroundColor: "black",
                    color: "white",
                  },
                }}
                onClick={() => navigate("/pet-management")}
              >
                {t('cancel')}
              </Button>
            </Box>
          )}
        </Box>
      </Box>
      <Footer />

      <Dialog
        open={detachTag}
        onClose={() => setDetachTag(false)}
        disableScrollLock={true}
        PaperProps={{
          sx: {
            borderRadius: 4,
            maxWidth: 400,
            width: "100%",
            p: 3,
            m: 2,
            boxSizing: "border-box",
            textAlign: "center",
            backgroundColor: "#FCF8F3",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            fontWeight: 700,
            fontSize: 20,
            justifyContent: "center",
            gap: 1,
          }}
        >
          {t('asktodetach')} {basicInfo.tagId} ?
        </Box>
        <DialogContent sx={{ pt: 0, pb: 0 }}>
          <Typography
            variant="body1"
            sx={{ mb: 3, textAlign: "center", fontSize: 16 }}
          >
            {t('Systemwilldelete')}
          </Typography>
        </DialogContent>
        <DialogActions
          sx={{
            flexDirection: "column",
            "& > :not(style) ~ :not(style)": {
              marginLeft: 0,
            },
          }}
        >
          <Button
            fullWidth
            variant="contained"
            sx={{
              backgroundColor: "var(--color-button-primary)",
              color: "#050505",
              fontWeight: 700,
              fontSize: 16,
              borderRadius: 2,
              py: 1,
              mb: 1,
              textAlign: "center",
              textTransform: 'none',
              "&:hover": { backgroundColor: "#8e7400ff" },
            }}
            onClick={() => { basicInfo.tagId = ""; setDetachTag(false); setShowPreview(false); }}
          >
            {t('Confirm')}
          </Button>
          <Button
            fullWidth
            variant="text"
            sx={{
              color: "#B0B0B0",
              fontWeight: 700,
              fontSize: 16,
              borderRadius: 2,
              py: 1,
              textAlign: "center",
              textTransform: 'none',
            }}
            onClick={() => {
              setDetachTag(false);
            }}
          >
            {t('cancel')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={embedTag}
        onClose={() => setEmbedTag(false)}
        disableScrollLock={true}
        PaperProps={{
          sx: {
            borderRadius: 4,
            maxWidth: 400,
            width: "100%",
            p: 3,
            m: 2,
            boxSizing: "border-box",
            textAlign: "center",
            backgroundColor: "#FCF8F3",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            fontWeight: 700,
            fontSize: 20,
            justifyContent: "center",
            gap: 1,
          }}
        >
          {t('pleaseEnterPetID')}
        </Box>
        <TextField
          placeholder={t('PetID')}
          maxLength="10"
          sx={{ my: 2, backgroundColor: "white", }}
          value={TagId}
          onChange={(e) => {
            setTagId(e.target.value.toUpperCase());
            if (inputError) setInputError("");
          }}>

        </TextField>
        {inputError && (
          <>
            <Alert
              severity="error"
              sx={{
                px: 1,
                textAlign: "left",
                alignItems: "flex-start",
                "& .MuiAlert-message": {
                  width: "100%",
                  textAlign: "left",
                },
                backgroundColor: "rgba(211, 47, 47, 0.1)", // optional: light red background
              }}
            >
              {inputError}
            </Alert>
          </>
        )}
        <DialogActions
          sx={{
            flexDirection: "column",
            "& > :not(style) ~ :not(style)": {
              marginLeft: 0,
            },
          }}
        >
          <Button
            fullWidth
            variant="contained"
            disabled={buttonLoading2}
            sx={{
              backgroundColor: "#FFB60C",
              color: "#050505",
              fontWeight: 700,
              fontSize: 16,
              borderRadius: 2,
              py: 1,
              mb: 1,
              textAlign: "center",
              textTransform: 'none',
              "&:hover": { backgroundColor: "#8e7400ff" },
              "&:disabled": { background: "rgba(255, 182, 12, 0.5)" },
              cursor: buttonLoading2 ? "not-allowed" : "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
            }}
            onClick={() => { submitTagId(TagId); }}
          >
            {t('Confirm')}
            {buttonLoading2 && (
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <CircularProgress size={15} color="inherit" />
              </span>
            )}
          </Button>
          <Button
            fullWidth
            variant="text"
            sx={{
              color: "#B0B0B0",
              fontWeight: 700,
              fontSize: 16,
              borderRadius: 2,
              py: 1,
              textAlign: "center",
              textTransform: 'none',
            }}
            onClick={() => {
              setEmbedTag(false);
            }}
          >
            {t('cancel')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Toast Notification */}
      <Box
        sx={{
          position: "fixed",
          bottom: 20,
          right: (success || error) ? 20 : -400,
          backgroundColor: BackColor,
          color: "#fff",
          padding: "16px 24px",
          borderRadius: 2,
          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          zIndex: 9999,
          minWidth: 250,
          display: "flex",
          alignItems: "center",
          gap: 2,
          transition: (success || error)
            ? "right 0.4s ease-out"
            : "right 0.4s ease-in",
        }}
      >
        <Box
          sx={{
            width: 24,
            height: 24,
            borderRadius: "50%",
            backgroundColor: "#fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          {error ? (
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M18 6L6 18M6 6L18 18"
                stroke={BackColor}
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          ) : (
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20 6L9 17L4 12"
                stroke={BackColor}
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          )}
        </Box>
        <Typography fontWeight={600} fontSize={isMobile ? 14 : 16}>
          {UpdateMessage}
        </Typography>
      </Box>

      <Dialog
        open={showFaceID}
        onClose={() => { setShowFaceID(false); }}
        disableScrollLock={true}
        PaperProps={{
          sx: {
            borderRadius: 4,
            maxWidth: 400,
            width: "100%",
            p: 3,
            m: 2,
            boxSizing: "border-box",
            textAlign: "center",
            backgroundColor: "#FCF8F3",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            fontWeight: 700,
            fontSize: 20,
            justifyContent: "center",
            gap: 1,
          }}
        >
          {t('FaceIDHead')}
        </Box>
        <DialogContent sx={{ p: 0 }}>
          <Typography
            variant="body1"
            sx={{ mb: 1, textAlign: "center", fontSize: 16 }}
          >
            {t('FaceIDContent')}
          </Typography>
        </DialogContent>
        <DialogActions
          sx={{
            flexDirection: "column",
            "& > :not(style) ~ :not(style)": {
              marginLeft: 0,
            },
          }}
        >
          <Button
            fullWidth
            variant="contained"
            sx={{
              backgroundColor: "var(--color-button-primary)",
              color: "#050505",
              fontWeight: 700,
              fontSize: 16,
              borderRadius: 2,
              py: 1,
              mb: 1,
              textAlign: "center",
              textTransform: 'none',
              "&:hover": { backgroundColor: "#8e7400ff" },
            }}
            onClick={() => { setShowFaceID(false); navigate(`/pet-management?faceID=${newPetID}`); }}
          >
            {t('register')}
          </Button>
          <Button
            fullWidth
            variant="text"
            sx={{
              color: "#B0B0B0",
              fontWeight: 700,
              fontSize: 16,
              borderRadius: 2,
              py: 1,
              textAlign: "center",
              textTransform: 'none',
            }}
            onClick={() => {
              setShowFaceID(false);
              navigate("/pet-management");
            }}
          >
            {t('later')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={showPetLost}
        onClose={() => { setShowPetLost(false); }}
        disableScrollLock={true}
        PaperProps={{
          sx: {
            borderRadius: 4,
            maxWidth: 400,
            width: "100%",
            p: 3,
            m: 2,
            boxSizing: "border-box",
            textAlign: "center",
            backgroundColor: "#FCF8F3",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            fontWeight: 700,
            fontSize: 20,
            justifyContent: "center",
            gap: 1,
          }}
        >
          {t('PetLostHead')}
        </Box>
        <DialogContent sx={{ p: 0, }}>
          <Box
            sx={{ mb: 3, textAlign: "center", fontSize: 16 }}
          >
            <div dangerouslySetInnerHTML={{ __html: t('PetLostContent') }} />
          </Box>
        </DialogContent>
        <DialogActions
          sx={{
            flexDirection: "column",
            "& > :not(style) ~ :not(style)": {
              marginLeft: 0,
            },
          }}
        >
          <Button
            fullWidth
            variant="contained"
            sx={{
              backgroundColor: "var(--color-button-primary)",
              color: "#050505",
              fontWeight: 700,
              fontSize: 16,
              borderRadius: 2,
              py: 1,
              mb: 1,
              textAlign: "center",
              textTransform: 'none',
              "&:hover": { backgroundColor: "#8e7400ff" },
            }}
            onClick={() => { setShowPetLost(false); navigate(`/pet_lost_report?member=true&created=true`); }}
          >
            {t('Report')}
          </Button>
          <Button
            fullWidth
            variant="text"
            sx={{
              color: "#B0B0B0",
              fontWeight: 700,
              fontSize: 16,
              borderRadius: 2,
              py: 1,
              textAlign: "center",
              textTransform: 'none',
            }}
            onClick={() => {
              setShowPetLost(false);
            }}
          >
            {t('later')}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default PetBasic;



